import { render, staticRenderFns } from "./AppPieChart.vue?vue&type=template&id=16febff8&"
import script from "./AppPieChart.vue?vue&type=script&lang=js&"
export * from "./AppPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports